/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicDailyGovernanceReport extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicDailyGovernanceReport");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicDailyGovernanceReport.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicDailyGovernanceReport>): BackgroundJobPayloadForPeriodicDailyGovernanceReport {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicDailyGovernanceReport(), model);
        BackgroundJobPayloadForPeriodicDailyGovernanceReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicDailyGovernanceReport>): BackgroundJobPayloadForPeriodicDailyGovernanceReport {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicDailyGovernanceReport.newInstance(<BackgroundJobPayloadForPeriodicDailyGovernanceReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicDailyGovernanceReport) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicDailyGovernanceReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicDailyGovernanceReport): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicDailyGovernanceReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
